import { ROUTES } from './routes';
import { ROUTE_TITLES } from './titles';

// Submodule names
export const MODULE_HOME = ROUTE_TITLES[ROUTES.HOME];
export const MODULE_SETUP = ROUTE_TITLES[ROUTES.SETUP_DASHBOARD];
export const MODULE_ANALYZING = ROUTE_TITLES[ROUTES.ANALYZING_DASHBOARD];
export const MODULE_COMMUNICATION = ROUTE_TITLES[ROUTES.COMMUNICATION_DASHBOARD];
export const MODULE_PROSPECTING = ROUTE_TITLES[ROUTES.PROSPECTING_DASHBOARD];
export const MODULE_MONITORING = ROUTE_TITLES[ROUTES.MONITORING_DASHBOARD];
export const MODULE_ADMIN = ROUTE_TITLES[ROUTES.ADMIN_DASHBOARD];

// Module type IDs that map to subscription types
export const MODULE_TYPE_COMMUNICATION = 1;
export const MODULE_TYPE_PROSPECTING = 2;
export const MODULE_TYPE_MONITORING = 3;
export const MODULE_TYPE_ANY_PAID = 'any-paid-module';

// Excluded routes - also exported for use in AdminSidebar
export const EXCLUDED_ROUTES = [
  // Admin routes
  ROUTES.ADMIN_BLOG_POST_EDIT,
  ROUTES.ADMIN_BLOG_POST_NEW,
  ROUTES.ADMIN_NEWSLETTER_EDIT,
  ROUTES.ADMIN_NEWSLETTER_NEW_STRUCTURED,
  ROUTES.ADMIN_NEWSLETTER_SELECT_TYPE,
  ROUTES.ADMIN_NEWSLETTER_PREVIEW,
  // Setup routes
  ROUTES.SETUP_COPRO_AREA,
  // Communication routes
  ROUTES.COMMUNICATION_UNSUBSCRIBERS,
  // Analyzing routes
  ROUTES.ANALYZING_GENERATE_SALES_REPORT,
  ROUTES.ANALYZING_COPRO_VIGILANCE,
  ROUTES.ANALYZING_GESTIONNAIRES_COPROS,
  ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_MANAGER,
  ROUTES.COMMUNICATION_GENERAL_ASSEMBLY_REFERENT,
  ROUTES.ANALYZING_COPRO_MANAGING,
  ROUTES.ANALYZING_GENERATE_COPRO_REPORT,
  // Communication routes
  ROUTES.REFERENT_APPOINTMENTS_NEW,
  ROUTES.REFERENT_APPOINTMENTS_SCHEDULED,
  ROUTES.REFERENT_APPOINTMENTS_TRACKING,
  ROUTES.REFERENT_APPOINTMENTS_TEMPLATE_CLIENT,
  ROUTES.REFERENT_APPOINTMENTS_TEMPLATE_COLLAB,
  ROUTES.REFERENT_APPOINTMENTS_TEMPLATE_RELANCE,
  ROUTES.REFERENT_APPOINTMENTS_TEAM_SALES,
  ROUTES.REFERENT_APPOINTMENTS_TEAM_RENTAL,
  ROUTES.REFERENT_APPOINTMENTS_TEAM_PLANNING,
  ROUTES.COMMUNICATION_NEWSLETTER_TEMPLATE_SELECTION,
  // Prospecting routes
  ROUTES.PROSPECTING_DPE_VISION,
  ROUTES.PROSPECTING_GENERATE_DPE_REPORT,
  ROUTES.PROSPECTING_SCIS_RENT,
  ROUTES.PROSPECTING_TEAM_PERFORMANCE,
  ROUTES.PROSPECTING_SCIS_REFERENT,
  // Communication routes (additional exclusions)
  ROUTES.REFERENT_APPOINTMENTS,
  ROUTES.COMMUNICATION_SCI_UNSUBSCRIBERS,
  // Setup routes (additional exclusions)
  ROUTES.SETUP_NAF_EXCLUSION,
  // Monitoring routes (hidden)
  ROUTES.MONITORING_BAUX_COMMERCIAUX,
  ROUTES.MONITORING_ENTREPRISES_EN_DEFAILLANCE,
  ROUTES.MONITORING_INSURANCE_EXCLUSIONS,
  ROUTES.MONITORING_BAUX_A_ECHEANCE,
];


export const MODULES = [
  {
    title: MODULE_ANALYZING,
    subtitle: 'Sécurisez vos inscriptions au RNIC pour éviter l\'amende et obtenez les statistiques du potentiel de CA transaction et location de votre parc',
    route: ROUTES.ANALYZING_DASHBOARD,
    img: null,
    displayDashboard: true,
    displayHeader: true,
    freemium: true,
    moduleTypeId: null, // Freemium module, no type ID needed
  },
  {
    title: MODULE_SETUP,
    subtitle: 'Paramétrer votre parc pour utiliser les modules suivants',
    route: ROUTES.SETUP_DASHBOARD,
    img: require('../../img/baux_commerciaux.webp'),
    displayDashboard: true,
    displayHeader: true,
    freemium: false, // Changed to false since it now requires paid access
    moduleTypeId: MODULE_TYPE_ANY_PAID, // Requires any paid module access
  },
  {
    title: MODULE_COMMUNICATION,
    subtitle: 'Communiquer avec vos copropriétaires',
    route: ROUTES.COMMUNICATION_DASHBOARD,
    img: require('../../img/communicationModule.webp'),
    displayDashboard: true,
    displayHeader: true,
    freemium: false,
    moduleTypeId: MODULE_TYPE_COMMUNICATION, // Maps to 'communicating' subscription
  },
  {
    title: MODULE_PROSPECTING,
    subtitle: 'Prospecter des nouvelles opportunités',
    route: ROUTES.PROSPECTING_DASHBOARD,
    img: require('../../img/transaction.webp'),
    displayDashboard: true,
    displayHeader: true,
    freemium: false,
    moduleTypeId: MODULE_TYPE_PROSPECTING, // Maps to 'prospecting' subscription
  },
  {
    title: MODULE_MONITORING,
    subtitle: 'Surveiller les entreprises et SCIs',
    route: ROUTES.MONITORING_DASHBOARD,
    img: require('../../img/piloter.png'),
    displayDashboard: true,
    displayHeader: true,
    freemium: false,
    moduleTypeId: MODULE_TYPE_MONITORING, // Maps to 'monitoring' subscription
  },
  {
    title: MODULE_ADMIN,
    route: ROUTES.ADMIN_DASHBOARD,
    img: null,
    displayDashboard: false,
    displayHeader: false,
    freemium: true,
    moduleTypeId: null, // Freemium module, no type ID needed
  },
].map(module => {  
  // Skip generating subitems for home
  if (module.route === ROUTES.HOME) {
    return { ...module, items: [] };
  }

  // Get the module prefix (e.g., '/analyzing/' from '/analyzing/market-vision')
  const modulePrefix = module.route.replace(/\/$/, ''); // Remove trailing slash if exists

  // Find all routes that start with this prefix
  const subItems = Object.entries(ROUTES)
    .filter(([key, path]) => {
      return path.startsWith(`${modulePrefix  }/`) && // Must start with prefix + '/'
             path !== module.route && // Exclude the main route
             !path.includes(':') && // Exclude routes with parameters
             !path.includes('*') && // Exclude wildcard routes
             key !== 'HOME' && // Exclude home route
             !EXCLUDED_ROUTES.includes(path); // Exclude excluded routes
    })
    .map(([key, path]) => ({
      title: ROUTE_TITLES[path] || key.split('_')
        .slice(1)
        .join(' ')
        .toLowerCase()
        .replaceAll(/\b\w/g, l => l.toUpperCase()),
      href: path,
    }));

  return { ...module, items: subItems };
});

const DASHBOARD_ROUTE_OVERRIDES: Record<string, string> = {
  [ROUTES.SETUP_DASHBOARD]: ROUTES.SETUP_SIMPLIFIED_DASHBOARD,
};

export function getModuleHref(module: typeof MODULES[0]): string {
  if (DASHBOARD_ROUTE_OVERRIDES[module.route]) {
    return DASHBOARD_ROUTE_OVERRIDES[module.route];
  }
  return module.items?.[0]?.href ?? module.route;
}